<p-dialog
  header="Share Guest Link"
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [style]="{width: '50vw', maxWidth: '600px', minWidth: '400px'}">

  <div *ngIf="session">
    <p>Send this URL to the guest participant so they can join session <strong>{{ session.sessionId }}</strong>.</p>

    <div class="guest-info-box">
      <i class="pi pi-user"></i>
      <span><strong>Guest:</strong> {{ session.guestUserIdentity }}</span>
    </div>

    <div class="guest-link-content">
      <div class="url-section">
        <label for="guestUrlInput">Guest Connection URL:</label>
        <div class="p-inputgroup">
          <input
            #guestUrlInput
            id="guestUrlInput"
            type="text"
            pInputText
            [value]="session.guestConnectUrl"
            readonly>
          <p-button
            icon="pi pi-copy"
            [outlined]="true"
            pTooltip="Copy to clipboard"
            (onClick)="copyGuestUrl()">
          </p-button>
        </div>
      </div>

      <div class="qr-section">
        <label>QR Code:</label>
        <div class="qr-code-container">
          <div *ngIf="guestLinkQRCode; else qrCodeError">
            <img
              [src]="guestLinkQRCode"
              alt="QR Code for Guest Link"
              class="qr-code-image">
            <p class="qr-caption">Scan to join session</p>
          </div>
          <ng-template #qrCodeError>
            <div class="qr-code-placeholder">
              <i class="pi pi-qrcode"></i>
            </div>
            <p class="qr-caption">QR code unavailable</p>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="guest-info-message">
      <i class="pi pi-info-circle"></i>
      <span>The guest can use this link to join the video session directly.</span>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      label="Close"
      icon="pi pi-times"
      [text]="true"
      (onClick)="closeDialog()">
    </p-button>
    <p-button
      label="Copy Link"
      icon="pi pi-copy"
      (onClick)="copyGuestUrl()">
    </p-button>
  </ng-template>
</p-dialog>
